<script setup lang="ts">
import { VIcon } from '@/modules/shared/components'

defineProps<{
  title: string
  price: string
  features?: string[]
  addOns?: { title: string; description?: string; price: string }[]
  totalDue?: string
  isRecommended?: boolean
}>()

const emit = defineEmits<{
  (e: 'click'): void
}>()
</script>

<template>
  <button type="button" class="mb-5 w-full cursor-pointer text-left" @click="emit('click')">
    <div
      class="relative flex flex-col space-y-0.5 rounded-[10px] bg-[#1f4f6a] transition-transform duration-200 hover:scale-[1.01]"
    >
      <div v-if="isRecommended" class="px-3 pb-1 pt-1.5 text-[11px] font-semibold uppercase text-white">
        Recommended
      </div>
      <div class="rounded-[10px] bg-[#3b88af] p-0.5">
        <div class="flex flex-col rounded-lg bg-white px-4 py-6">
          <div
            class="absolute -bottom-2.5 left-1/2 flex -translate-x-1/2 items-center gap-1 rounded-full bg-[#3b88af] px-2 py-1 text-[11px] font-semibold uppercase text-white"
          >
            <VIcon name="Check" class="h-4 w-4" />
            <span>Selected</span>
          </div>

          <div class="flex flex-wrap items-center justify-between">
            <div class="text-lg font-medium text-gray-900">{{ title }}</div>
            <div class="text-xl font-semibold text-[#1f4f6a]">{{ price }}</div>
          </div>

          <ul v-if="features?.length" class="mt-4 space-y-2 text-sm text-gray-600">
            <li v-for="label in features" :key="label" class="flex items-start gap-2">
              <span class="mt-0.5 flex shrink-0 items-center">
                <VIcon name="Check" class="h-4 w-4 text-[#1f4f6a]" />
              </span>
              <span>{{ label }}</span>
            </li>
          </ul>

          <div v-if="addOns?.length" class="mt-4 space-y-2">
            <div
              v-for="addOn in addOns"
              :key="addOn.title"
              class="rounded-lg border border-gray-300 bg-white px-4 py-3"
            >
              <div class="flex items-start justify-between gap-4">
                <div>
                  <div class="text-sm font-medium text-gray-900">{{ addOn.title }}</div>
                  <p v-if="addOn.description" class="mt-0.5 text-xs text-gray-500">{{ addOn.description }}</p>
                </div>
                <div class="text-sm font-semibold text-gray-900">{{ addOn.price }}</div>
              </div>
            </div>
          </div>

          <div v-if="totalDue" class="mt-4 flex items-center justify-between border-t border-gray-100 pt-4">
            <span class="text-sm font-semibold text-gray-700">Total due</span>
            <span class="text-lg font-bold text-[#1f4f6a]">{{ totalDue }}</span>
          </div>
        </div>
      </div>
    </div>
  </button>
</template>
